import { render, staticRenderFns } from "./main_app.vue?vue&type=template&id=010296a1"
import script from "./main_app.vue?vue&type=script&lang=js"
export * from "./main_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports